// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1CaTC","requiredAsterisk":"Info_requiredAsterisk__27VSd"};